export const UNASSIGNED = "__unassigned__";

// Status change endpoints. Only the approve endpoint was given; decline/reset
// mirror its shape ({ contractNumbers: [...] }) — adjust the URLs to match the API.
export const STATUS_ENDPOINT = {
  Approved: "/api/commission/contracts/approve",
  Declined: "/api/commission/contracts/decline",
  Pending: "/api/commission/contracts/reset",
};

export const CommissionStatus = Object.freeze({
    Pending: "Pending",
    Approved: "Approved",
    Declined: "Declined"
});